export function isNotEmpty<T>(array: T[]): boolean {
  return array.length > 0;
}
